import { useMutation } from "react-query";
import {fetchBmcaSecondSignerSignData} from "../services/bmcaSecondSigner";

function useBmcaSecondSigner() {
  return useMutation(["second-signer-bmca"], fetchBmcaSecondSignerSignData);
}

export default useBmcaSecondSigner;